import Handlebars from "handlebars";

import "./handlebarsHelpers";

export default function renderHandlebarsTemplate({ template, data }) {
	return Handlebars.compile(template)(data);
}
